import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { PriceLogBaseModel } from "./priceLogBaseModel"
import { PriceAdjustmentType } from "../../constants/priceAdjustmentType"
import { PriceChangeType } from "../../constants/priceChangeType"
import { SubAreaModel } from "../subAreaModel"

@Serializable
export class PriceLogAdjustmentModel extends PriceLogBaseModel {
  adjustmentType: PriceAdjustmentType = PriceAdjustmentType.Undefined
  adjustmentAmount: number = 0

  constructor(
    data: {
      uid: string
      changeType: PriceChangeType
      created: string
      createdByName: string
      createdByEmail: string
      comment: string
      subAreasFrom: SubAreaModel[]
      subAreasTo: SubAreaModel[]
      adjustmentType: PriceAdjustmentType
      adjustmentAmount: number
    } | null = null,
  ) {
    super(data)
    if (data) {
      this.adjustmentType = data.adjustmentType
      this.adjustmentAmount = data.adjustmentAmount
    }
  }
}
